import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Tabs } from 'antd';
import { useNicService } from 'stores/nic/useNicService';
import { DirectoryEntities } from '@nice-devone/common-sdk';
import { TransferFlowWrapper } from './styled';
import AgentsTab from './AgentsTab';
import SkillsTab from './SkillsTab';
import PhoneTab from './PhoneTab';
var TAB_ITEMS = [
    { key: 'agents', label: 'Agents', children: _jsx(AgentsTab, {}) },
    { key: 'skills', label: 'Skills', children: _jsx(SkillsTab, {}) },
    { key: 'phone', label: 'Phone', children: _jsx(PhoneTab, {}) }
];
var AdditionalDirectory = function () {
    var loadDirectoryData = useNicService().loadDirectoryData;
    useEffect(function () {
        var cleanup = loadDirectoryData({
            entity: [
                DirectoryEntities.AGENT_LIST,
                DirectoryEntities.SKILL_LIST,
                DirectoryEntities.TEAM_LIST
            ]
        });
        return function () { return cleanup && cleanup(); };
    }, [loadDirectoryData]);
    return (_jsx(TransferFlowWrapper, { children: _jsx(Tabs, { defaultActiveKey: "agents", size: "small", style: { padding: '0 16px' }, items: TAB_ITEMS }) }));
};
export default AdditionalDirectory;
